import * as React from 'react';

type Props = {
	accent?: string;
	primary?: string;
} & React.SVGProps<SVGSVGElement>;

function ProjectionsIcon({ accent, primary, ...props }: Props) {
	return (
		<svg
			fill="currentColor"
			height="17"
			viewBox="0 0 17 17"
			width="17"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M15.5932 14.5507H1.38447V0.808434C1.38447 0.36999 1.0351 -0.0870854 0.6 0.014259C0.248685 0.0960875 0 0.36999 0 0.808434V15.2201C0 15.6588 0.182082 16.0143 0.40678 16.0143H15.5932C15.8179 16.0143 16 15.6588 16 15.2201C16 14.7817 15.8179 14.5507 15.5932 14.5507Z"
				fill={primary ?? 'white'}
			/>
			<path
				d="M4.4141 11.5928L4.41626 11.5928C4.57981 11.5926 4.73436 11.5207 4.84195 11.3969L4.84207 11.3968L9.25914 6.3036L10.3321 7.53822L10.3321 7.53823L10.3332 7.53946C10.4636 7.68617 10.658 7.75751 10.8515 7.72658L10.8515 7.72674L10.8584 7.72529C10.982 7.6995 11.0941 7.63457 11.1791 7.54054L11.1791 7.54056L11.181 7.5383L15.0126 3.12569V4.04886C15.0126 4.36591 15.2625 4.63175 15.5813 4.63175C15.9001 4.63175 16.15 4.36591 16.15 4.04886V1.59C16.15 1.27278 15.9001 1.0071 15.5813 1.0071H13.203C12.8844 1.0071 12.6343 1.27276 12.6343 1.59C12.6343 1.90708 12.8844 2.17289 13.203 2.17289H14.3148L10.7578 6.27587L9.68476 5.03857L9.68482 5.03851L9.68148 5.03491C9.57203 4.91674 9.41938 4.84886 9.25878 4.84886C9.09818 4.84886 8.94553 4.91674 8.83608 5.03491L8.83602 5.03486L8.8328 5.03856L3.98991 10.6228L3.98989 10.6228L3.98831 10.6247C3.8439 10.7968 3.80979 11.0382 3.89916 11.2446L3.8992 11.2447C3.98893 11.4516 4.18863 11.5898 4.4141 11.5928Z"
				fill={accent ?? 'currentColor'}
				stroke={accent ?? 'white'}
				strokeWidth="0.3"
			/>
		</svg>
	);
}

export default ProjectionsIcon;
